import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex items-center flex-wrap gap-1 text-sm" itemScope itemType="https://schema.org/BreadcrumbList">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              {item.href && !isLast ? (
                <Link to={item.href} className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap" itemProp="item">
                  <span itemProp="name">{item.label}</span>
                </Link>
              ) : (
                <span className={`whitespace-nowrap ${isLast ? 'text-foreground-900 font-medium' : 'text-foreground-500'}`} itemProp="name">
                  {item.label}
                </span>
              )}
              <meta itemProp="position" content={String(index + 1)} />
              {!isLast && (
                <span className="text-foreground-300 mx-0.5">/</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}